var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 6.00195C13.1974 6.00195 14.342 6.47606 15.1859 7.31997C16.0298 8.16389 16.5039 9.30848 16.5039 10.502V15.752H13.5039V10.502C13.5039 10.1041 13.3459 9.7226 13.0646 9.44129C12.7833 9.15999 12.4017 9.00195 12.0039 9.00195C11.6061 9.00195 11.2246 9.15999 10.9432 9.44129C10.6619 9.7226 10.5039 10.1041 10.5039 10.502V15.752H7.50391V10.502C7.50391 9.30848 7.97801 8.16389 8.82193 7.31997C9.66584 6.47606 10.8104 6.00195 12.0039 6.00195Z",
    stroke: "#0129FA",
    strokeWidth: 0.851064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50488 6.75098H1.50488V15.751H4.50488V6.75098Z",
    stroke: "#0129FA",
    strokeWidth: 0.851064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00488 4.50195C3.83331 4.50195 4.50488 3.83038 4.50488 3.00195C4.50488 2.17353 3.83331 1.50195 3.00488 1.50195C2.17646 1.50195 1.50488 2.17353 1.50488 3.00195C1.50488 3.83038 2.17646 4.50195 3.00488 4.50195Z",
    stroke: "#0129FA",
    strokeWidth: 0.851064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.781106167a6bc63d49bad2b63466ae6d.svg";
export { ForwardRef as ReactComponent };